import { executeApiCall } from 'services/api';
import { getMutations } from 'entities/hooks/mutation';

import { SuccessData } from 'types/api';
import { TeamService } from '../types';

export type FormTeamService = Omit<TeamService, 'id' | 'team'> & { id?: string };

export const serviceMutations = getMutations({
  toggleService: {
    action: async ({ id, disabled }: { id: string; disabled: boolean }): Promise<SuccessData> => {
      return executeApiCall({
        path: `/teams/services/status`,
        payload: {
          id,
          disabled,
        },
      });
    },
  },

  // for the services we keep the validation on the usage due to its complex nature
  // later we should have a section that exports validations to be used inside the comp

  createService: {
    action: async (payload: FormTeamService): Promise<TeamService> => {
      return executeApiCall({
        path: `/teams/services`,
        payload,
      });
    },
  },

  updateService: {
    action: async (payload: FormTeamService): Promise<TeamService> => {
      return executeApiCall({
        path: `/teams/services`,
        payload,
        method: 'put',
      });
    },
  },
});
